<template>
    <div>
        <Breadcumb title="Bonnes pratiques : Article 1" :breadcumb-data="breadcumbData">
        </Breadcumb>
        <b-card class="mb-4 cardcontainer" footer-class="pt-0 px-0 pb-3">
            <div class="media flex-wrap align-items-center" slot="header">
                <div class="media-body ml-3">
                    <a href="javascript:void(0)">Alexandre Dupont</a>
                    <div class="text-muted small">11/02/2021</div>
                </div>
            </div>
            
            <div>
                Célébrer : Derrière ce mot se cache la convivialité. Favoriser une bonne ambiance de travail a de nombreuses vertus. Celle-ci peut l’être par l’organisation d’événements pour « célébrer les réussites de l’entreprise dans un environnement compétitif » par exemple, qui permet également de décompresser de manière collective. Parrainages, déjeuners d’accueil, afterworks, séminaire, Noël de l’entreprise, anniversaire des salariés célébrés en salle de pause, journées sportives… Il existe de nombreux moyens pour créer du lien de manière informelle et renforcer l’esprit d’équipe et d’entraide.
            </div>
            
            <div slot="footer" class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="px-4 pt-3">
                    <a href="javascript:void(0)" class="text-muted">
                        <i class="ion ion-ios-heart-empty text-danger text-large align-middle"></i>&nbsp;
                        <span class="align-middle">Nombre de Like</span>
                    </a>
                    <span class="text-muted ml-4">
          </span>
                </div>
                <div class="px-4 pt-3">
                    <b-btn variant="primary"><i class="ion ion-md-create"></i>&nbsp; Répondre</b-btn>
                </div>
            </div>
        </b-card>
        <b-card class="mb-3">
            <b-form-group label="Votre commentaire" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                <b-textarea placeholder="Votre commentaire" :rows="5" v-model="comment"/>
            </b-form-group>
            <b-btn v-on:click="addComment" variant="primary"><i class="ion ion-md-create"></i>&nbsp; Répondre</b-btn>
        </b-card>
        <div>
            <b-card class="mb-3">
                <div class="media">
                    <div class="media-body ml-4">
                        <div class="float-right text-muted small">20/02/2021</div>
                        <a href="javascript:void(0)">Christophe Marie</a>
                        <div class="mt-2">
                            Merci beaucoup pour cet éclairage
                        </div>
                    </div>
                </div>
            
            </b-card>
        </div>
    
    </div>
</template>

<script>
    import * as numeral from 'numeral'
    import Breadcumb from '../components/breadcumb'
    import { mapState } from 'vuex';

    export default {
        name: 'pages-forums-discussion',
        components: { Breadcumb},
        computed: mapState({ article: state => state.exchange.article}),
        data() {
            return {
                breadcumbData: [],
                comment: '',
            }
        },
        methods: {
            addComment: function(e) {
                e.preventDefault()
            }
        },
        mounted () {
                this.breadcumbData = [
                        {text: this.$t('welcome'), href: '/dashboard/'},
                        {text: "Bonnes pratiques", href: '/share/guidelines/'},
                        {text: "Guide bonnes pratiques 1", active:true}
                    ];
                    console.log(this.breadcumbData)
        }
    }
</script>
